import { render } from "./Reports.vue?vue&type=template&id=30e06bc0&scoped=true&ts=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=30e06bc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e06bc0"]])

export default __exports__